export default {
  lighthouse: {
    apiHost: 'https://lighthouse-api.harbortouch.com',
  },
};
